export const steps = [
    'Register Account',
    'Connect To Bank',
    'Select Round-Up Accounts',
    'Select Funding Account'
  ];